import React from 'react'

const StripeCard = ({ card }) => {
    const ext = card?.externalAccount;
    const hasBank = ext?.last4 && ext?.currency;
    const name = card?.businessName || ext?.bank_name || 'Stripe account';
    // A linked account whose Stripe setup isn't finished can't receive payments
    // yet — show it (so the organizer sees the link worked) but flag it.
    const pending = !card?.payoutEnabled;
    return (
        <div className="card " style={{ width: 'fit-content' }}>
            <div className="card-body">
                <blockquote className="blockquote mb-0">
                    <p className="card-cont">
                        {pending ? (
                            <>
                                {name}{' '}
                                <span className="card-currency" style={{ color: '#b26a00' }}>
                                    Setup incomplete — finish in Stripe to receive payments
                                </span>
                            </>
                        ) : hasBank ? (
                            <>
                                CAD account {ext.bank_name} ending with *{ext.last4}{' '}
                                <span className="card-currency">
                                    Default for{' '}
                                    <span style={{ textTransform: 'uppercase' }}>{ext.currency}</span>
                                </span>
                            </>
                        ) : (
                            // OAuth-linked Standard accounts: Stripe hides bank details from the
                            // platform, so show the connected business/account name instead.
                            <>
                                {name}{' '}
                                <span className="card-currency">Connected</span>
                            </>
                        )}
                    </p>
                </blockquote>
            </div>
        </div>
    )
}

export default StripeCard
